import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Popular from "./pages/Popular";
import Demo from "./pages/Demo";
import Categories from "./pages/Categories";
import MovieDetails from "./pages/MovieDetails";
import ActorDetails from "./pages/ActorDetails";
import Footer from "./components/footer";
import Categorie from "./pages/Categorie";
import APropos from "./pages/APropos";
import ScrollToTop from "./components/ScrollToTop";

const App = () => {
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Switch>
          <Route path="/" exact component={Popular} />
          <Route path="/demo" exact component={Demo} />
          <Route path="/categories" exact component={Categories} />
          <Route path="/categorie/:idGenre/:categoryName" component={Categorie} />
          <Route path="/movieDetails/:id" exact component={MovieDetails} />
          <Route path="/actorDetails/:id" exact component={ActorDetails} />
          <Route path="/footer" exact component={Footer} />
         <Route path="/APropos" exact component={APropos} />
        </Switch>
      </BrowserRouter>
    )
}

export default App;